import { WebPlugin } from '@capacitor/core';
export class PrivacyScreenWeb extends WebPlugin {
    constructor() {
        super({
            name: 'PrivacyScreen',
            platforms: ['web'],
        });
    }
}
const PrivacyScreen = new PrivacyScreenWeb();
export { PrivacyScreen };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(PrivacyScreen);
//# sourceMappingURL=web.js.map